import React, { useContext, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import MyProSidebar from "../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../COMPONENTS/navbar/Topbar";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import UpdateDisabledOutlinedIcon from "@mui/icons-material/UpdateDisabledOutlined";
import Header from "../../COMPONENTS/header/Header";
import StatBox from "../../COMPONENTS/StatBox";
import axios from "axios";
import "./home.css";
import AuthContext from "../../CONTEXT/AuthProvider";

function Home() {
  const [disputeStats, setDisputeStats] = useState();

  const [countNonUpdatedContracts, setCountNonUpdatedContracts] = useState();
  const [countClosedDisputes, setCountClosedDisputes] = useState();
  const [countActiveDisputes, setCountActiveDisputes] = useState();
  const [subscriberRank, setSubscriberRank] = useState();
  const { auth } = useContext(AuthContext);
  const subscribername = auth.subscriberName;
  const digitalLendor = auth.digitalLendor;
  const staff = auth.staff;
  const accessToken = auth.accessToken;

  useEffect(() => {
    if (staff === "Yes" || subscribername === "BANK OF TANZANIA") {
      axios
        .get("/api/nonUpdated-Contracts")
        .then((response) => {
          const dataResponse = response.data;
          setCountNonUpdatedContracts(dataResponse.length);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      axios
        .get("/api/nonUpdated-Contracts")
        .then((response) => {
          const dataResponse = response.data.filter(
            (subscribers) =>
              subscribers["Subscriber"] === subscribername ||
              subscribers["Subscriber"] === digitalLendor
          );
          setCountNonUpdatedContracts(dataResponse.length);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [subscribername, staff, digitalLendor]);

  useEffect(() => {
    if (staff === "Yes" || subscribername === "BANK OF TANZANIA") {
      axios
        .get("/api/active-disputes", {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        })
        .then((response) => {
          const dataResponse = response.data;
          setCountActiveDisputes(dataResponse.length);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      axios
        .get("/api/active-disputes", {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        })
        .then((response) => {
          const dataResponse = response.data.filter(
            (subscribers) =>
              subscribers["Subscriber Name"] === subscribername ||
              subscribers["Subscriber Name"] === digitalLendor
          );
          setCountActiveDisputes(dataResponse.length);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [subscribername, staff, accessToken, digitalLendor]);

  useEffect(() => {
    if (staff === "Yes" || subscribername === "BANK OF TANZANIA") {
      axios
        .get("/api/closed-disputes", {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        })
        .then((response) => {
          const dataResponse = response.data;
          setCountClosedDisputes(dataResponse.length);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      axios
        .get("/api/closed-disputes", {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        })
        .then((response) => {
          const dataResponse = response.data.filter(
            (subscribers) =>
              subscribers["Subscriber Name"] === subscribername ||
              subscribers["Subscriber Name"] === digitalLendor
          );
          setCountClosedDisputes(dataResponse.length);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [subscribername, staff, accessToken, digitalLendor]);

  useEffect(() => {
    if (staff === "Yes" || subscribername === "BANK OF TANZANIA") {
      axios
        .get("/api/disputes-stats", {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        })
        .then((response) => {
          const dataResponse = response.data.map((subscribers, index) => ({
            ...subscribers,
            rowNumber: index + 1,
          }));
          setDisputeStats(dataResponse);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      axios
        .get("/api/disputes-stats", {
          headers: {
            Authorization: "Bearer " + accessToken,
          },
        })
        .then((response) => {
          const dataResponse = response.data
            .filter(
              (subscribers) =>
                subscribers["subscriberName"] === subscribername ||
                subscribers["subscriberName"] === digitalLendor
            )
            .map((subscribers, index) => ({
              ...subscribers,
              rowNumber: index + 1,
            }));

          console.log(dataResponse);
          setDisputeStats(dataResponse);
          setSubscriberRank(dataResponse[0]?.rank);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [subscribername, staff, accessToken, digitalLendor]);

  const columns = [
    {
      field: "rowNumber",
      headerName: "#",
      flex: 0.2,
    },
    {
      field: "subscriberName",
      headerName: "Institution Name",
      flex: 1.3,
    },
    {
      field: "totalActiveDisputes",
      headerName: "Open Disputes",
      flex: 0.5,
    },
    {
      field: "rank",
      headerName: "Rank",
      flex: 0.4,
      renderCell: (params) => {
        const rank = params.value;
        const cellClassName = rank < 11 ? "red-zone" : "";
        return <div className={cellClassName}>{rank}</div>;
      },
    },
    {
      field: "totalClosedDisputes",
      headerName: "Closed Disputes",
      flex: 0.5,
    },
    {
      field: "age0_15",
      headerName: "Age(0-15)",
      flex: 0.4,
      headerClassName: "custom-header-rone",
    },
    {
      field: "age16_30",
      headerName: "Age(16-30)",
      flex: 0.4,
      headerClassName: "custom-header-rtwo",
    },
    {
      field: "age31_60",
      headerName: "Age(31-60)",
      flex: 0.4,
      headerClassName: "custom-header-rthree",
    },
    {
      field: "age61_90",
      headerName: "Age(61-90)",
      flex: 0.4,
      headerClassName: "custom-header-rfour",
    },
    {
      field: "ageGreaterThan90",
      headerName: "Age(>=90)",
      flex: 0.4,
      headerClassName: "custom-header-rfive",
    },
  ];

  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        {auth.disputeManagement === "1" && (
          <Box m="20px">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Header title="DASHBOARD" subtitle="Welcome to your dashboard" />
            </Box>

            {/* GRID & CHARTS */}
            <Box
              display="grid"
              gridTemplateColumns="repeat(12, 1fr)"
              gridAutoRows="140px"
              gap="20px"
            >
              {staff === "No" && subscribername !== "BANK OF TANZANIA" ? (
                <>
                  <Box
                    gridColumn="span 3"
                    backgroundColor="#f2f0f0"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    {subscriberRank > 0 ? (
                      <StatBox
                        title={`Rank - ${subscriberRank}`}
                        subtitle="Rank according to active no. of disputes"
                        icon={
                          <AssessmentOutlinedIcon
                            sx={{ color: "#70d8bd", fontSize: "26px" }}
                          />
                        }
                      />
                    ) : (
                      <StatBox
                        title="No active disputes"
                        subtitle="Rank according to active no. of disputes"
                        icon={
                          <AssessmentOutlinedIcon
                            sx={{ color: "#70d8bd", fontSize: "26px" }}
                          />
                        }
                      />
                    )}
                  </Box>

                  <Box
                    gridColumn="span 3"
                    backgroundColor="#f2f0f0"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <StatBox
                      title={countActiveDisputes}
                      subtitle="Active Disputes"
                      icon={
                        <LockOpenOutlinedIcon
                          sx={{ color: "#70d8bd", fontSize: "26px" }}
                        />
                      }
                    />
                  </Box>

                  <Box
                    gridColumn="span 3"
                    backgroundColor="#f2f0f0"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <StatBox
                      title={countClosedDisputes}
                      subtitle="Closed Disputes"
                      icon={
                        <LockOutlinedIcon
                          sx={{ color: "#70d8bd", fontSize: "26px" }}
                        />
                      }
                    />
                  </Box>

                  <Box
                    gridColumn="span 3"
                    backgroundColor="#f2f0f0"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <StatBox
                      title={countNonUpdatedContracts || 0}
                      subtitle="Non Updated Contracts"
                      icon={
                        <UpdateDisabledOutlinedIcon
                          sx={{ color: "#70d8bd", fontSize: "26px" }}
                        />
                      }
                    />
                  </Box>
                </>
              ) : (
                <>
                  <Box
                    gridColumn="span 4"
                    backgroundColor="#f2f0f0"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <StatBox
                      title={countActiveDisputes}
                      subtitle="Active Disputes"
                      icon={
                        <LockOpenOutlinedIcon
                          sx={{ color: "#70d8bd", fontSize: "26px" }}
                        />
                      }
                    />
                  </Box>

                  <Box
                    gridColumn="span 4"
                    backgroundColor="#f2f0f0"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <StatBox
                      title={countClosedDisputes}
                      subtitle="Closed Disputes"
                      icon={
                        <LockOutlinedIcon
                          sx={{ color: "#70d8bd", fontSize: "26px" }}
                        />
                      }
                    />
                  </Box>

                  <Box
                    gridColumn="span 4"
                    backgroundColor="#f2f0f0"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <StatBox
                      title={countNonUpdatedContracts || 0}
                      subtitle="Non Updated Contracts"
                      icon={
                        <UpdateDisabledOutlinedIcon
                          sx={{ color: "#70d8bd", fontSize: "26px" }}
                        />
                      }
                    />
                  </Box>
                </>
              )}
            </Box>

            {/* SUBSCRIBERS TABLE */}
            <Box
              m="40px 0 0 0"
              height="auto"
              sx={{
                "& .MuiDataGrid-root": {
                  border: "none",
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                },
                "& .name-column--cell": {
                  color: "#2e7c67",
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#bbbbbb",
                  borderBottom: "none",
                },
                "& .MuiDataGrid-virtualScroller": {
                  backgroundColor: "#f2f0f0",
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "none",
                  backgroundColor: "#bbbbbb",
                },
                "& .MuiCheckbox-root": {
                  color: `${"#1e5245"} !important`,
                },
                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                  color: `${"#525252"} !important`,
                },
              }}
            >
              <DataGrid
                rows={disputeStats || []}
                columns={columns}
                components={{ Toolbar: GridToolbar }}
              />
            </Box>

            {/* <Box display="flex" justifyContent="end" mt="30px">
            <Link
              to="graphicAnalysis"
              variant="contained"
              className="analysis-link"
            >
              More Graphic Analysis
            </Link>
          </Box> */}
          </Box>
        )}
      </main>
    </div>
  );
}

export default Home;
